require('./app-bootstrap');         // Объявление многих переменных в window
require('./componentsTemplates');   // Вюшки которые были подключены автопилотом для всех страниц
require('./on-document-ready');     // Скрипты которые нужно пнуть после загрузки страницы
